var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H513V342H0V0Z",
    fill: "#055E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.906 204.451C183.906 216.771 193.656 226.756 205.685 226.756H271.02C271.02 237.02 279.146 245.343 289.17 245.343H310.948C320.972 245.343 329.098 237.021 329.098 226.756V204.451H183.906ZM330.909 96.6464V148.69C330.909 156.889 324.396 163.559 316.39 163.559V185.863C336.405 185.863 352.686 169.188 352.686 148.69V96.6464H330.909ZM174.832 148.691C174.832 156.89 168.319 163.56 160.312 163.56V185.864C180.328 185.864 196.609 169.189 196.609 148.691V96.6474H174.831V148.691H174.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.242 96.6434H320.02V148.687H298.242V96.6434ZM265.574 126.386C265.574 128.436 263.946 130.104 261.944 130.104C259.942 130.104 258.314 128.436 258.314 126.386V96.6464H236.536V126.386C236.536 128.436 234.907 130.104 232.906 130.104C230.904 130.104 229.276 128.436 229.276 126.386V96.6464H207.497V126.386C207.497 140.734 218.895 152.408 232.905 152.408C238.3 152.408 243.305 150.672 247.424 147.722C251.542 150.672 256.548 152.408 261.943 152.408C263.029 152.408 264.097 152.33 265.149 152.193C263.606 158.704 257.88 163.56 251.054 163.56V185.864C271.069 185.864 287.351 169.189 287.351 148.691V96.6464H265.572L265.574 126.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.497 163.556H240.162V185.86H207.497V163.556Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArFlag);
export default __webpack_public_path__ + "static/media/ar-flag.e5d70ccbfd01234b277da1aa0a06a3f0.svg";
export { ForwardRef as ReactComponent };